import Path from '../../../services/paths'
import utils from '../../common/utils'
import PromotionListAction from '../../prat_actions/promotion/promotionListAction'
import DownloadXlxActions from '../../actions/downloadXlxActions';
import axios from 'axios'
import { setHeaders } from '../../../util-functions/util-funtions'
import CustomToast from '../../../util-functions/customToast.jsx'

export default class PromotionListMiddleware {
  static get_promotionList(versionPage,
    selectedYear,
    selectedWeekFrom,
    selectedWeekTo,
    selectedProductCategories,
    selectedProductBrands,
    selectedProductMasterSkus,
    selectedActivityStatus,
    selectedPromotionType,
    selectedActivityCode,
    selectedPushToDW,
    selectedIsextended,
    selectedInvoiceOption,
    selectedRPFailOption
    ) {
    let url = `${Path.BASE_URL}/activity/?page=${versionPage}&limit=20&`;
    if (selectedYear) {
      url += `year=${selectedYear}&`
    }

    if (selectedWeekFrom) {
      url += `week_from=${selectedWeekFrom}&`
    }

    if (selectedWeekTo) {
      url += `week_to=${selectedWeekTo}&`
    }

    if (Array.isArray(selectedProductCategories)) {
      selectedProductCategories.forEach(element => {
        url += `category=${element}&`;
      });
    }
    if (Array.isArray(selectedProductBrands)) {
      selectedProductBrands.forEach(element => {
        url += `brand=${element}&`;
      });
    }
    if (Array.isArray(selectedProductMasterSkus)) {
      selectedProductMasterSkus.forEach(element => {
        url += `sku=${element}&`;
      });
    }
    if (Array.isArray(selectedActivityStatus)) {
      selectedActivityStatus.forEach(element => {
        url += `activity_status=${element}&`;
      });
    }
    if (Array.isArray(selectedPromotionType)) {
      selectedPromotionType.forEach(element => {
        url += `promotion_type=${element}&`;
      });
    }
    // if (selectedPromotionType) {
    //   url += `promotion_type=${selectedPromotionType}&`
    // }
    if (Array.isArray(selectedActivityCode)) {
      selectedActivityCode.forEach(element => {
        url += `code=${element}&`;
      })
    }
    if (selectedPushToDW || selectedPushToDW === false) {
      url += `push_to_dwh=${selectedPushToDW}&`
    }
    if (selectedIsextended || selectedIsextended === false) {
      url += `is_extended=${selectedIsextended}&`
    }
    if (selectedInvoiceOption || selectedInvoiceOption === false) {
      url += `is_invoice_on=${selectedInvoiceOption}&`
    }
    if (selectedRPFailOption || selectedRPFailOption === false) {
      url += `is_rp_failed=${selectedRPFailOption}&`
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(PromotionListAction.promotionList_Request());
      utils.get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: setHeaders(false, token, false)
          })
            .then(data => {
              if (data.data.detail === 'Invalid page.') {
                dispatch(PromotionListAction.promotionList_Failed(data.data.detail))
              }
              else {
                dispatch(PromotionListAction.promotionList_Success(data.data))
              }
            })
            .catch(err => {
              dispatch(PromotionListAction.promotionList_Failed(err.message))
            })
        })
        .catch(err => {
          dispatch(PromotionListAction.promotionList_Failed(err.message))

        })
    }
  };


  static delete_promotion(data) {
    return dispatch => {
      dispatch(PromotionListAction.promotion_delete_Request());
      utils.get_token()
        .then(token => {
          fetch(`${Path.DELETE_PROMOTION}`, {
            method: 'DELETE',
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ "guids": data })
          })
            .then(res => res.json())
            .then(data => {
              dispatch(PromotionListAction.promotion_delete_Success(data))
            })
            .catch(err => {
              dispatch(PromotionListAction.promotion_delete_Failed(err.message))
            })
        })
        .catch(err => {
          dispatch(PromotionListAction.promotion_delete_Failed(err.message))

        })
    }
  };



  static bulk_approve_promotion(data) {
    return dispatch => {
      dispatch(PromotionListAction.promotion_bulk_approve_Request());
      utils.get_token()
        .then(token => {
          fetch(`${Path.BULK_APPROVE_PROMOTIONS}`, {
            method: 'POST',
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ "guids": data })
          })
            .then(res => res.json())
            .then(data => {
              if (data.detail) {
                // ToastsStore.error(data.detail)
                CustomToast('error', data.detail)
              } else {
                dispatch(PromotionListAction.promotion_bulk_approve_Success(data))
                // ToastsStore.success('Approved Successfully')
                CustomToast('success', 'Approved Successfully')
              }
            })
            .catch(err => {
              dispatch(PromotionListAction.promotion_bulk_approve_Failed(err.message))
            })
        })
        .catch(err => {
          dispatch(PromotionListAction.promotion_bulk_approve_Failed(err.message))

        })
    }
  };



  static bulk_duplicate_promotion(data,year) {
    return dispatch => {
      dispatch(PromotionListAction.promotion_bulk_duplicate_Request());
      utils.get_token()
        .then(token => {
          fetch(`${Path.BULK_DUPLICATE_PROMOTIONS}`, {
            method: 'POST',
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ "guids": data,"year":year })
          })
            .then(res => res.json())
            .then(data => {
              if (data.detail) {
                CustomToast('error', data.detail)
              }
              else if(data[0]){
                CustomToast('error', data[0])
              }
               else {
                dispatch(PromotionListAction.promotion_bulk_duplicate_Success(data))
                CustomToast('success', 'Duplicated Successfully')
              }
            })
            .catch(err => {
              dispatch(PromotionListAction.promotion_bulk_duplicate_Failed(err.message))
            })
        })
        .catch(err => {
          dispatch(PromotionListAction.promotion_bulk_duplicate_Failed(err.message))

        })
    }
  }



  static download_promotion_list_Xlx(
    versionPage,
    selectedYear,
    selectedWeekFrom,
    selectedWeekTo,
    selectedProductCategories,
    selectedProductBrands,
    selectedProductMasterSkus,
    selectedActivityStatus,
    selectedPromotionType,
    selectedActivityCode
  ) {
    let url = `${Path.DOWNLOAD_PROMOTION_LIST}?`;
    if (versionPage) {
      url += `page=${versionPage}&`
    }

    if (selectedYear) {
      url += `year=${selectedYear}&`
    }

    if (selectedWeekFrom) {
      url += `week_from=${selectedWeekFrom}&`
    }

    if (selectedWeekTo) {
      url += `week_to=${selectedWeekTo}&`
    }

    if (Array.isArray(selectedProductCategories)) {
      selectedProductCategories.forEach(element => {
        url += `category=${element}&`;
      });
    }
    if (Array.isArray(selectedProductBrands)) {
      selectedProductBrands.forEach(element => {
        url += `brand=${element}&`;
      });
    }
    if (Array.isArray(selectedProductMasterSkus)) {
      selectedProductMasterSkus.forEach(element => {
        url += `sku=${element}&`;
      });
    }
    if (Array.isArray(selectedActivityStatus)) {
      selectedActivityStatus.forEach(element => {
        url += `activity_status=${element}&`;
      });
    }
    if (selectedPromotionType) {
      url += `promotion_type=${selectedPromotionType}&`
    }
    if (Array.isArray(selectedActivityCode)) {
      selectedActivityCode.forEach(element => {
        url += `code=${element}&`;
      })
    }

    url = url.slice(0, -1);
    return dispatch => {
      dispatch(DownloadXlxActions.downloadXlxRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            responseType: 'blob',
            headers: {
              "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.error) {
              } else {
                let fileName = res.headers['content-disposition'].slice(res.headers['content-disposition'].indexOf('=') + 1)
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
                // ToastsStore.success("Download Successful")
                CustomToast('success', 'Download Successful')
                dispatch(DownloadXlxActions.downloadXlxSuccessul(res));
              }
            })
            .catch(error => {
              // ToastsStore.error("Download Failed!");
              CustomToast('error', 'Download Failed!')
              dispatch(DownloadXlxActions.downloadXlxFailed(error));
            });
        })
        .catch(error => {
          dispatch(DownloadXlxActions.downloadXlxFailed(error));
        });
    };
  }


  static bulk_send_back_promotion(data) {
    return dispatch => {
      dispatch(PromotionListAction.promotion_bulk_send_back_Request());
      utils.get_token()
        .then(token => {
          fetch(`${Path.BULK_SEND_BACK_PROMOTION}`, {
            method: 'POST',
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ "guids": data })
          })
            .then(res => res.json())
            .then(data => {
              if (data.detail) {
                // ToastsStore.error(data.detail)
                CustomToast('error', data.detail)
              } else {
                dispatch(PromotionListAction.promotion_bulk_send_back_Success(data))
                // ToastsStore.success('Send Back Successfully')
                CustomToast('success' , 'Send Back Successfully')
              }
            })
            .catch(err => {
              dispatch(PromotionListAction.promotion_bulk_send_back_Failed(err.message))
            })
        })
        .catch(err => {
          dispatch(PromotionListAction.promotion_bulk_send_back_Failed(err.message))

        })
    }
  };

  static promotion_extension(data) {
    return dispatch => {
      dispatch(PromotionListAction.promotion_extension_Request());
      utils.get_token()
        .then(token => {
          fetch(`${Path.BASE_URL}/activity/${data}/promotion_extension/`, {
            method: 'POST',
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token}`
            },
            // body: JSON.stringify({ "guids": data })
          })
            .then(res => res.json())
            .then(data => {
              if (data.detail === 'Activity has been extended successfully') {
                dispatch(PromotionListAction.promotion_extension_Success(data))
                // ToastsStore.success('Activity has been extended succesfully')
                CustomToast('success', 'Activity has been extended succesfully')
              } else {
                // return ToastsStore.error('promotion extension api fail')
                if(data.detail === 'This activity is already completed, and cannot be extended. Please raise another activity!'){
                  return CustomToast('error', data.detail)
                }
                return CustomToast('error', 'promotion extension api fail')
              }
            })
            .catch(err => {
              dispatch(PromotionListAction.promotion_extension_Failed(err.message))
            })
        })
        .catch(err => {
          dispatch(PromotionListAction.promotion_extension_Failed(err.message))

        })
    }
  };

  static bulk_rp_call(data) {
    return dispatch => {
      dispatch(PromotionListAction.bulk_rp_call_Request());
      utils.get_token()
        .then(token => {
          fetch(`${Path.BULK_RP_CALL}`, {
            method: 'POST',
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ "guids": data })
          })
            .then(res => res.json())
            .then(data => {
              if (data.detail) {
                CustomToast('error', data.detail)
              } else {
                dispatch(PromotionListAction.bulk_rp_call_Success(data))
                CustomToast('success' , 'RP Call Successfully')
              }
            })
            .catch(err => {
              dispatch(PromotionListAction.bulk_rp_call_Failed(err.message))
            })
        })
        .catch(err => {
          dispatch(PromotionListAction.bulk_rp_call_Failed(err.message))

        })
    }
  };

  static bulk_duplicate_next_year_promotion(data,year) {
    return dispatch => {
      dispatch(PromotionListAction.promotion_bulk_duplicate_next_year_Request());
      utils.get_token()
        .then(token => {
          fetch(`${Path.BULK_DUPLICATE_NEXT_YEAR}`, {
            method: 'POST',
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ "guids": data,"year":year })
          })
            .then(res => res.json())
            .then(data => {
              if (data.detail) {
                CustomToast('error', data.detail)
              }
              else if(data[0]){
                CustomToast('error', data[0])
              }
               else {
                dispatch(PromotionListAction.promotion_bulk_duplicate_next_year_Success(data))
                CustomToast('success', 'Duplicated Successfully')
              }
            })
            .catch(err => {
              dispatch(PromotionListAction.promotion_bulk_duplicate_next_year_Failed(err.message))
            })
        })
        .catch(err => {
          dispatch(PromotionListAction.promotion_bulk_duplicate_next_year_Failed(err.message))

        })
    }
  }

}

